import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from '@/config/environment';

class AppInsightsService {
  private client: ApplicationInsights | null = null;
  private enabled = false;

  constructor() {
    const key = environment.appInsights.instrumentationKey;
    if (key && key !== 'none') {
      this.client = new ApplicationInsights({
        config: {
          instrumentationKey: key,
          enableAutoRouteTracking: true,
        },
      });
      this.client.loadAppInsights();
      this.enabled = true;
    }
  }

  logAuthentication(userId: string) {
    if (this.enabled) this.client?.setAuthenticatedUserContext(userId);
  }

  logPageView(name?: string, url?: string) {
    if (this.enabled) this.client?.trackPageView({ name, uri: url });
  }

  logEvent(name: string, properties?: Record<string, string>) {
    if (this.enabled) this.client?.trackEvent({ name }, properties);
  }

  logException(error: Error, severityLevel?: number) {
    if (this.enabled) this.client?.trackException({ error, severityLevel });
  }

  logTrace(message: string, severityLevel?: number) {
    if (this.enabled) this.client?.trackTrace({ message, severityLevel });
  }

  logLogout() {
    if (this.enabled) this.client?.clearAuthenticatedUserContext();
  }
}

export const appInsights = new AppInsightsService();
